/* 
    可配置多级路由，添加权限修改Layout中的createMenu方法，
    createMenu方法会将router数组第一个对象渲染到侧边栏，其它路由隐藏，如登录、打印、404页面
*/
import { lazy } from "react";
import Home from "../Pages/homepage/homepage";

import About from "../Pages/About";
import Brief from "../Pages/About/comp/Brief";
import Historycomp from "../Pages/About/comp/History";
import Director from "../Pages/About/comp/Director";
import Honor from "../Pages/About/comp/Honor";
import Partner from "../Pages/About/comp/Partner";
import ProdLayout from "../Pages/ProdandSolution/index";
import Prod from "../Pages/ProdandSolution/prod";
import Join from "../Pages/Join";
import Joinus from "../Pages/Join/comp/index";
import Board from "../Pages/Join/comp/board";
import Solution from "../Pages/ProdandSolution/solution";
import Service from "../Pages/Service";
import News from "../Pages/News";
import NewsDetail from "../Pages/NewsDetail";
import Notice from "../Pages/Notice";
import Search from ".././Pages/Search";

import { Navigate } from "react-router-dom";

import Pay from "../Pages/ProdandSolution/prodDetail/comp/pay";
import Posmis from "../Pages/ProdandSolution/prodDetail/comp/posmis";
import Upay from "../Pages/ProdandSolution/prodDetail/comp/upay";
import Cloud from "../Pages/ProdandSolution/prodDetail/comp/cloud";
import Fz from "../Pages/ProdandSolution/prodDetail/comp/fz";
import Xwyd from "../Pages/ProdandSolution/prodDetail/comp/xwyd";
import Yxt from "../Pages/ProdandSolution/prodDetail/comp/yxt";
import Yyt from "../Pages/ProdandSolution/prodDetail/comp/yyt";
import Ito from "../Pages/Service/comp/ito";
import Bpo from "../Pages/Service/comp/bpo";
import Retail from "../Pages/ProdandSolution/solutionDetail/retail";
import Medical from "../Pages/ProdandSolution/solutionDetail/medical";
import School from "../Pages/ProdandSolution/solutionDetail/school";
import Park from "../Pages/ProdandSolution/solutionDetail/park";
import NewsCenter from "../Pages/News/comp/center";
import Paper from "../Pages/News/comp/paper";

// const Pay = lazy(() => {
//   return import("../Pages/ProdandSolution/prodDetail/comp/pay");
// });
// const Posmis = lazy(() => {
//   return import("../Pages/ProdandSolution/prodDetail/comp/posmis");
// });
// const Upay = lazy(() => {
//   return import("../Pages/ProdandSolution/prodDetail/comp/upay");
// });
// const Cloud = lazy(() => {
//   return import("../Pages/ProdandSolution/prodDetail/comp/cloud");
// });
// const Fz = lazy(() => {
//   return import("../Pages/ProdandSolution/prodDetail/comp/fz");
// });
// const Xwyd = lazy(() => {
//   return import("../Pages/ProdandSolution/prodDetail/comp/xwyd");
// });
// const Yxt = lazy(() => {
//   return import("../Pages/ProdandSolution/prodDetail/comp/yxt");
// });
// const Yyt = lazy(() => {
//   return import("../Pages/ProdandSolution/prodDetail/comp/yyt");
// });
// const Ito = lazy(() => {
//   return import("../Pages/Service/comp/ito");
// });
// const Bpo = lazy(() => {
//   return import("../Pages/Service/comp/bpo");
// });
// const Retail = lazy(() => {
//   return import("../Pages/ProdandSolution/solutionDetail/retail");
// });
// const Medical = lazy(() => {
//   return import("../Pages/ProdandSolution/solutionDetail/medical");
// });
// const School = lazy(() => {
//   return import("../Pages/ProdandSolution/solutionDetail/school");
// });
// const Park = lazy(() => {
//   return import("../Pages/ProdandSolution/solutionDetail/park");
// });

const router = [
  { path: "/", element: <Home /> },
  {
    path: "/about",
    element: <About />,
    children: [
      {
        path: "/about/director",
        name: "$singlee_ab_md2",
        element: <Director />,
      },
      { path: "/about/brief", name: "$singlee_ab_md1", element: <Brief /> },
      {
        path: "/about/history",
        name: "$singlee_ab_md3",
        element: <Historycomp />,
      },
      { path: "/about/honor", name: "$singlee_ab_md4", element: <Honor /> },
      { path: "/about/partner", name: "$singlee_ab_md5", element: <Partner /> },
    ],
  },
  {
    path: "/prodandsolution",
    element: <ProdLayout />,
    children: [
      {
        path: "/prodandsolution/prod",
        name: "产品",
        element: <Prod />,
        children: [
          {
            path: "/prodandsolution/prod/pay",
            name: "线上统一支付收银台",
            element: <Pay />,
          },
          {
            path: "/prodandsolution/prod/posmis",
            name: "POS-MIS",
            element: <Posmis />,
          },
          {
            path: "/prodandsolution/prod/upay",
            name: "UPAY",
            element: <Upay />,
          },
          {
            path: "/prodandsolution/prod/cloud",
            name: "对账云平台",
            element: <Cloud />,
          },
          {
            path: "/prodandsolution/prod/fz",
            name: "分账系统",
            element: <Fz />,
          },
          {
            path: "/prodandsolution/prod/xwyd",
            name: "小微云店",
            element: <Xwyd />,
          },
          {
            path: "/prodandsolution/prod/yxt",
            name: "银校通",
            element: <Yxt />,
          },
          {
            path: "/prodandsolution/prod/yyt",
            name: "银医通",
            element: <Yyt />,
          },
        ],
      },
      {
        path: "/prodandsolution/solution",
        name: "解决方案",
        element: <Solution />,
        children: [
          {
            path: "/prodandsolution/solution/retail",
            name: "$singlee_cr1",
            element: <Retail />,
          },
          {
            path: "/prodandsolution/solution/medical",
            name: "$singlee_yl1",
            element: <Medical />,
          },
          {
            path: "/prodandsolution/solution/school",
            name: "$singlee_sc1",
            element: <School />,
          },
          {
            path: "/prodandsolution/solution/park",
            name: "$singlee_pk1",
            element: <Park />,
          },
        ],
      },
    ],
  },
  {
    path: "/join",
    element: <Join />,
    children: [
      {
        path: "/join/joinus",
        name: "加入我们",
        element: <Joinus />,
      },
      {
        path: "/join/board",
        name: "留言板",
        element: <Board />,
      },
    ],
  },
  {
    path: "/service",
    element: <Service />,
    children: [
      {
        path: "/service/ito",
        name: "信息技术服务外包",
        element: <Ito />,
      },
      {
        path: "/service/bpo",
        name: "业务流程外包",
        element: <Bpo />,
      },
    ],
  },
  {
    path: "/news",
    element: <News />,
    children: [
      {
        path: "/news/center",
        name: "新闻中心",
        element: <NewsCenter />,
      },
      {
        path: "/news/paper",
        name: "$singlee_nw3",
        element: <Paper />,
      }
    ],
  },
  {
    path: "/newsdetail",
    element: <NewsDetail />,
    name: "新闻详情",
  },
  {
    path: "/notice",
    element: <Notice />,
    name: "公司公告",
  },
  {
    path: "/search",
    element: <Search />,
    name: "搜索页",
  },
  { path: "*", element: <Navigate to="/" /> },
];
export default router;
